import { ThemeService } from './../Services/theme.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable()

export class ThemeResolver  {
    constructor(
        private readonly themeService: ThemeService,
    ) {
    }

    resolve(
        _route: ActivatedRouteSnapshot,
        _state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | string {
        return this.themeService.themeLogoVariable;
    }
}
